// extracted by mini-css-extract-plugin
export default {"title":"select_domain_title__5ptOt","domain_card_wrapper":"select_domain_domain_card_wrapper__z5CSc"};